import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import AssignmentIndRoundedIcon from "@mui/icons-material/AssignmentIndRounded";
// import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CoreButtonHoverIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import CoreTable from "../../../app/core/components/CoreTable/CoreTable";
import { TABLE_ROWS_NUMBER } from "../../../utils/constants/tables";
import { useGetCommercialistaQuery } from "../../api/admin/gestisciCommercialistiApi";
import { doReportOperator } from "./gestisciOperatoriSlice.js";
import { useGetStudiosQuery } from "../../api/admin/gestisciStudioApi";
import { useTranslation } from "react-i18next";
import UserFilter from "../../../app/core/components/UserFilter/UserFilter";
import CoreFilter from "../../../app/core/components/CoreFilter/CoreFilter";
import AutocompleteFilter from "../../../app/core/components/CoreFilter/components/AutocompleteFilter/AutocompleteFilter";
import {
  removeGlobalFilter,
  selectAllFilters,
  setMultipleGlobalFilters,
} from "../../../app/globalFiltersSlice";
import { ROLE } from "../../../utils/constants/profiles.js";
import useSyncFilterWithGlobalFilters from "../../../utils/hookCustom.js";
import { useGetUsersQuery } from "../../api/admin/gestisciUtentiApi";
import { useGetRolesQuery } from "../../api/admin/rolesApi";

const GestisciCommercialistiPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const role = useSelector((state) => state.app.role);
  const [rows, setRows] = useState([]);
  const [user, setUser] = useState();
  const [debouncedInputUserValue, setDebouncedInputUserValue] = useState("");
  const [debouncedInputStudioValue, setDebouncedInputStudioValue] =
    useState("");
  const [page, setPage] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  });
  const [filter, setFilter] = useState({
    identityRoleId: "",
    studioId: "",
  });

  const columns = {
    name: t("Name"),
    surname: t("Surname"),
    email: "Email",
    adminProfileRoles: t("Role"),
    // studioName: t("StudioLocation"),
  };

  const { data, error, isLoading, isFetching, refetch } =
    useGetCommercialistaQuery({
      page,
      value: debouncedInputUserValue,
      filter,
    });

  const { data: operatorsData } = useGetCommercialistaQuery({
    page: page,
  });

  const {
    data: usersData,
    isLoading: isUsersLoading,
    isFetching: isUsersFetching,
  } = useGetUsersQuery({
    page: { startRow: 0, endRow: 100 },
    value: debouncedInputUserValue,
  });

  const { data: rolesData } = useGetRolesQuery(filter);

  const { data: adminStudio } = useGetStudiosQuery({
    ...page,
    value: debouncedInputStudioValue,
  });

  const globalFilters = useSelector(selectAllFilters);

  useEffect(() => {
    const isValidation = data && data?.Data && data?.Data?.items;
    if (isValidation) {
      // tutti i dati degli utenti
      const userData = data?.Data?.items.map((el) => ({
        id: el.id,
        name: el.name,
        surname: el.surname,
        email: el.email,
        adminProfileRoles: el?.adminProfileRoles[0]?.roleName,
        studioName: el.studioName,
      }));
      // Dati della tabella
      setRows(userData);
    }
  }, [data]);

  const handleOpen = (el) => {
    navigate(`${el.id}`);
  };

  const handleDownload = () => {
    toast.info("Il report è in fase di download");
    dispatch(doReportOperator());
  };

  const actions = [
    {
      icon: <AssignmentIndRoundedIcon />,
      onClick: handleOpen,
      tooltip: t("Card") + " " + t("Operator"),
    },
  ];

  const handleRefecthDocuments = () => {
    refetch();
  };

  useSyncFilterWithGlobalFilters(setFilter);

  const transformFilters = (filtersArray) => {
    const filterObject = {
      studioId: "",
      adminId: "",
      userId: "",
      identityRoleId: "",
    };

    filtersArray.forEach((filter) => {
      if (
        filter.key &&
        Object.prototype.hasOwnProperty.call(filterObject, filter.key)
      ) {
        filterObject[filter.key] = filter.value || "";
      }
    });

    return filterObject;
  };

  const handleFiltersChange = (newFilters) => {
    // Trasforma i filtri nel formato desiderato
    const transformedFilters = transformFilters(newFilters);
    // Ora puoi usare l'oggetto trasformato
    setFilter(transformedFilters);
  };

  const handleGlobalFiltersApply = (filters) => {
    // Separa i filtri con valori validi da quelli undefined/vuoti
    const validFilters = [];
    const filtersToRemove = [];

    filters.forEach((filter) => {
      if (filter.value !== undefined && filter.value !== "") {
        // Filtro con valore valido - mantienilo
        validFilters.push(filter);
      } else {
        // Filtro undefined o vuoto - rimuovilo
        filtersToRemove.push(filter.key);
      }
    });

    // Rimuovi i filtri undefined/vuoti dallo state
    filtersToRemove.forEach((filterKey) => {
      dispatch(removeGlobalFilter(filterKey));
    });

    // Imposta solo i filtri con valori validi
    if (validFilters.length > 0) {
      dispatch(setMultipleGlobalFilters(validFilters));
    }
  };

  if (isLoading) {
    return <CoreSpinner />;
  }

  return (
    <>
      <div className="flex flex-col">
        <h2 className="font-bold">{t("Operators")}</h2>
        <div className="flex flex-row -mt-16 justify-end space-x-2">
          <CoreFilter
            onFiltersChange={handleFiltersChange}
            onGlobalFiltersApply={handleGlobalFiltersApply}
            initialFilters={globalFilters}
          >
            {ROLE.ADMIN === role && (
              <AutocompleteFilter
                label="Cerca Studio"
                placeholder="Digita nome studio..."
                options={adminStudio?.Data?.items}
                filterKey="studioId"
                getOptionValue={(option) => option.id}
                getOptionLabel={(option) => option.name}
                allowGlobal={true}
              />
            )}

            <AutocompleteFilter
              label="Cerca Operatore"
              placeholder="Digita nome operatore..."
              options={operatorsData?.Data?.items}
              filterKey="adminId"
              getOptionValue={(option) => option.id}
              getOptionLabel={(option) => `${option.name} ${option.surname}`}
              allowGlobal={true}
            />

            <AutocompleteFilter
              label="Cerca Cliente"
              placeholder="Digita nome cliente..."
              options={usersData?.Data?.items}
              filterKey="userId"
              getOptionValue={(option) => option.id}
              getOptionLabel={(option) => `${option.name} ${option.surname}`}
              allowGlobal={true}
            />

            <AutocompleteFilter
              label="Tipo Operatore"
              placeholder="Tipo Operatore"
              options={rolesData?.Data?.map((el) => ({
                value: el.id,
                label: el.name,
              }))}
              filterKey="identityRoleId"
              getOptionValue={(option) => option.value}
              getOptionLabel={(option) => option.label}
            />
          </CoreFilter>
        </div>

        <div className="flex flex-row justify-between mt-10 ">
          <div className="w-4/12">
            <UserFilter
              selectedUser={user}
              setSelectedUser={setUser}
              usersList={data?.Data?.items}
              setDebouncedInputUserValue={setDebouncedInputUserValue}
              isUsersLoading={isLoading}
              setPage={setPage}
              externalLabel={`${t("BriefSearchOperator")}`}
              externalPlaceholder={`${t("ExtSearchOperator")}`}
              externalNegativeLabel={t("NoOperatorFound")}
            />
          </div>
          <div className="w-8/12 flex items-center">
            <CoreButtonHoverIcon
              onClick={handleRefecthDocuments}
              className="text-blue-500 m-1 flex flex-row space-x-2 border"
              testo={t("Refresh")}
              icon={<RefreshRoundedIcon className={`fill-blue-500`} />}
            />
            <CoreButtonHoverIcon
              className="text-blue-700 m-1"
              icon={<AddBoxRoundedIcon className={`fill-blue-700`} />}
              testo={`${t("Operator")}`}
              onClick={() =>
                navigate("/auth/admin/create-account", {
                  state: { operator: true },
                })
              }
            />
            {role === ROLE.STUDIO && (
              <CoreButtonHoverIcon
                className={"text-green-500 m-1"}
                onClick={() => navigate(`/auth/admin/${t("customize-studio")}`)}
                icon={
                  <EditRoundedIcon
                    fontSize="small"
                    className="text-green-500"
                  />
                }
                testo={t("Customize")}
              />
            )}
            {/* <CoreButtonHoverIcon
              className={"text-darkgray m-1"}
              icon={<DownloadRoundedIcon className="fill-darkgray" />}
              testo="Report"
              onClick={handleDownload}
            /> */}
          </div>
        </div>
      </div>

      <CoreTable
        check={false}
        rows={rows}
        columns={columns}
        button
        actions={actions}
        info={t("Operators")}
        setPage={setPage}
        page={page}
        totalPages={Math.ceil(data?.Data?.count / TABLE_ROWS_NUMBER) || 1}
        isLoading={isLoading || isFetching}
      />
    </>
  );
};

export default GestisciCommercialistiPage;
